import { create } from 'zustand';
import type { Node } from '@/types/node';

export interface PendingAssetInsertion {
  workflowId: string;
  nodes: Node[];
  groupBounds?: { x: number; y: number; width: number; height: number };
  groupColor?: string;
}

interface PendingAssetInsertionsState {
  insertions: Record<string, PendingAssetInsertion>;
  add: (id: string, insertion: PendingAssetInsertion) => void;
  remove: (id: string) => void;
}

export const usePendingAssetInsertions = create<PendingAssetInsertionsState>((set) => ({
  insertions: {},
  add: (id, insertion) => set((state) => ({ insertions: { ...state.insertions, [id]: insertion } })),
  remove: (id) =>
    set((state) => {
      const { [id]: _, ...insertions } = state.insertions;
      return { insertions };
    }),
}));
